@if (isLoaded) {
  <div class="content">
    @if (jobs.length) {
      <div layout-horizontal layout-space-between margin-bottom>
        <div layout-vertical>
          <rt-heading variant="heading large-x">{{
            'app.requisitions.jobs.heading' | translate
          }}</rt-heading>
          <span>{{ 'app.requisitions.jobs.subheading' | translate }}</span>
        </div>
        @if (hasCreateJob) {
          <rt-button (click)="createJob()" variant="primary">
            <rt-icon name="add"></rt-icon>
            {{ 'app.offers.new_job' | translate }}
          </rt-button>
        }
      </div>
      <rt-requisitions-jobs-list-container [jobs]="jobs"></rt-requisitions-jobs-list-container>
    } @else {
      @if (emptyStateVariant === 'not_approved') {
        <rt-empty-state
          [title]="'app.requisitions.jobs.empty_not_approved.title' | translate"
          [desc]="'app.requisitions.jobs.empty_not_approved.description' | translate"
          icon="work"
          variant="default"
          margin-top
        ></rt-empty-state>
      }
      @if (emptyStateVariant === 'no_jobs') {
        <rt-empty-state
          [title]="'app.requisitions.jobs.empty_no_jobs.title' | translate"
          [desc]="'app.requisitions.jobs.empty_no_jobs.description' | translate"
          icon="work"
          variant="default"
          margin-top
        >
          @if (hasCreateJob) {
            <rt-button (click)="createJob()" variant="primary">
              <rt-icon name="add"></rt-icon>
              {{ 'app.offers.new_job' | translate }}
            </rt-button>
          }
        </rt-empty-state>
      }
    }
  </div>
} @else {
  <rt-spinner></rt-spinner>
}
